import {PersonCapabilityType, personCapabilityTypes} from "@ots-frontend/ots-data";
import {BaseDbCodeMultiSelect, DbCodeMultiSelectProps} from "../base-db-code-multi-select";

type Props = DbCodeMultiSelectProps<PersonCapabilityType>;

export const PersonCapabilityTypeMultiSelect = (props: Props) => {
  const {options = personCapabilityTypes, ...rest} = props;
  return <BaseDbCodeMultiSelect options={options} {...rest} />;
};
